import { render, staticRenderFns } from "./RatingChart.vue?vue&type=template&id=21adbb5a&scoped=true"
import script from "./RatingChart.vue?vue&type=script&lang=js"
export * from "./RatingChart.vue?vue&type=script&lang=js"
import style0 from "./RatingChart.vue?vue&type=style&index=0&id=21adbb5a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21adbb5a",
  null
  
)

export default component.exports